/**
    顶部路由组件
    参数：
*/
<template>
  <div class="TRouteNav">
    <div class="wrapper">
      <div class="nav-brand">
          <router-link to="/" class="logo-link">
            <div class="logo-text">
              Gravity<span>Shop</span>
            </div>
          </router-link>
      </div>
      
      <div class="nav-main">
          <div class="nav-links">
              <div class="nav-link-item"
              v-for="item in this.arr.type"
              :key="item.value"
              @click="routLinkTo(item.route)"
              :class="{active: activeRoute === item.route }">
                  {{ item.des }}
              </div>
          </div>
          
          <div class="search-container">
            <div class="search-bar">
                <i class="el-icon-search search-icon"></i>
                <input type="text" placeholder="Search for products..." v-model="searchKeyWord" @keyup.enter="keyWordSearch">
            </div>
            <button class="search-btn" @click="keyWordSearch">Search</button>
          </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
    name: 'TopTypeNav',
    props: {
      obj: Object
    },
    data () {
      return {
        arr: {
          'type': [
            {
              'value': 0,
              'des': 'Home',
              'route': '/indexpage/index'
            },
            {
              'value': 1,
              'des': 'All Products',
              'route': '/indexpage/productlist'
            },
            {
              'value': 2,
              'des': 'Notice',
              'route': '/indexpage/notice'
            },
          ]
        },
        activeRoute: '/indexpage/index',
        searchKeyWord: ''
      }
    },
    watch: {
      $route (to, from) {
        this.activeRoute = to.path
      },
      obj: {
        handler (nVal, oVal) {
          var data = nVal.componentContent.typeRoute
          this.arr.type = data.map((item, index) => {
            return {
              'value': index,
              'des': item.des,
              'route': item.linkTo
            }
          })
        }
      }
    },
    methods: {
      routLinkTo (val) {
        if (!val || val === this.$route.path) return
        this.$router.push(val)
      },
      keyWordSearch () {
        this.$router.push({
          path: '/indexpage/productlist',
          query: {
            keyword: this.searchKeyWord
          }
        })
      }
    }
}
</script>

<style lang="scss" scoped>
@import "../../styles/variables.scss";

.TRouteNav {
  height: 90px;
  background-color: $white;
  box-shadow: $shadow-sm;
  position: sticky;
  top: 0;
  z-index: 1000;
  display: flex;
  align-items: center;

  .wrapper {
    max-width: 1440px;
    width: 100%;
    margin: 0 auto;
    padding: 0 40px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
}

.nav-brand {
  .logo-link {
    display: flex;
    align-items: center;
    .logo-text {
      font-size: 28px;
      font-weight: 800;
      color: #333;
      cursor: pointer;
      user-select: none;
      letter-spacing: -1px;
      span {
        color: $primary-color;
      }
    }
  }
}

.nav-main {
  display: flex;
  align-items: center;
  gap: 40px;
}

.nav-links {
  display: flex;
  gap: 30px;

  .nav-link-item {
    font-size: 16px;
    color: $gray-600;
    font-weight: 500;
    cursor: pointer;
    position: relative;
    padding: 10px 0;
    transition: $transition-fast;

    &::after {
      content: "";
      position: absolute;
      bottom: 0;
      left: 0;
      width: 0;
      height: 2px;
      background-color: $primary-color;
      transition: width 0.3s ease;
    }

    &:hover {
      color: $primary-color;
      &::after {
        width: 100%;
      }
    }

    &.active {
      color: $primary-color;
      &::after {
        width: 100%;
      }
    }
  }
}

.search-container {
  display: flex;
  align-items: center;
  gap: 12px;

  .search-bar {
    display: flex;
    align-items: center;
    background-color: $gray-100;
    border-radius: $border-radius-full;
    padding: 0 15px;
    border: 1px solid transparent;
    transition: $transition-fast;
    width: 280px;

    &:focus-within {
      background-color: $white;
      border-color: $primary-color;
      box-shadow: 0 0 0 3px rgba($primary-color, 0.1);
    }

    .search-icon {
      color: $gray-400;
      font-size: 18px;
    }

    input {
      border: none !important;
      background: none !important;
      box-shadow: none !important;
      padding: 8px 10px !important;
      font-size: 14px;
      flex: 1;
      height: 38px;
      
      &:focus {
        border: none !important;
        box-shadow: none !important;
      }
    }
  }

  .search-btn {
    background-color: $gray-900;
    color: $white;
    border: none;
    height: 40px;
    padding: 0 24px;
    border-radius: $border-radius-full;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
    transition: $transition-fast;
    flex-shrink: 0;

    &:hover {
      background-color: $primary-color;
      transform: translateY(-1px);
      box-shadow: $shadow-md;
    }

    &:active {
      transform: translateY(0);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/TopTypeNav.vue